/**
 * Decodifica o payload de um JWT. O segmento é Base64URL (sem padding, '-' e '_' no lugar de
 * '+' e '/') com conteúdo UTF-8; `atob` direto falha nesses casos. Não valida assinatura —
 * serve só para ler claims de uma sessão que o Supabase Auth já entregou.
 */
export function decodificarPayloadJwt(token: string): Record<string, unknown> | null {
  try {
    const segmento = token.split('.')[1];
    if (!segmento) return null;

    const b64 = segmento.replace(/-/g, '+').replace(/_/g, '/');
    const binario = atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4));
    const bytes = Uint8Array.from(binario, c => c.charCodeAt(0));
    const payload: unknown = JSON.parse(new TextDecoder().decode(bytes));

    return payload !== null && typeof payload === 'object' ? (payload as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}
